export default __webpack_public_path__ + "static/media/logo-lupaco.23f3cc6b.svg";